import o from "lodash-es/get.js";
const a = (m) => ({
  min: (r) => ({ theme: n }) => `@media (min-width: ${n[m][r]})`,
  max: (r) => ({ theme: n }) => `@media (max-width: ${n[m][r]})`
}), u = (m, {
  spacingName: r = "spacing",
  breakpointsName: n = "breakpoints"
} = {}) => Object.fromEntries(
  Object.keys(m).map((e) => [
    e,
    e === r ? (...t) => ({ theme: i }) => t.map((c) => i[e][c]).join(" ") : (t) => ({ theme: i }) => typeof t < "u" ? o(i[e], t) : i[e]
  ]).concat(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- it's fine, in practice this is handled by typecast below
    n in m ? [
      [
        "mediaQuery",
        a(n)
      ]
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- a bit too hard to type this
    ] : []
  ).concat([
    [
      "value",
      (e) => ({ theme: t }) => o(t, e)
    ],
    [
      "valueFromProp",
      (e, t, i) => (c) => o(
        c.theme,
        `${t}.${c[e] ?? i}`
      )
    ]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- a bit too hard to type this
  ])
);
export {
  u as generateHelpers
};
